export function slugify(value: string): string {
  const slug = value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

  return slug || "trivia-game";
}

export function randomToken(): string {
  const values = new Uint8Array(18);
  crypto.getRandomValues(values);
  return Array.from(values, (value) => value.toString(36).padStart(2, "0")).join("");
}

export function makeId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}_${randomToken().slice(0, 8)}`;
}
